var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
export class AppInfo {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    get isAppInEditBuild() {
        return this.app.appMode.isInEditMode && !!runtime.streamedPackages.Edit;
    }
    get isUserCurrentlyEditing() {
        return this.app.appInfo.isAppInEditBuild && !this.app.appMode.isInPreviewMode;
    }
    get isUserCurrentlyRunning() {
        return !this.isUserCurrentlyEditing;
    }
    get isAppPaused() {
        return false;
    }
    get instance() {
        return this.app.pathURI.split('/')[0];
    }
    get isPremiumApp() {
        if (runtime.isBot)
            return true;
        if (!!this.app.user && !!this.app.user.userInfo.isPremiumUser)
            return true;
        return false;
    }
    get isMobileAppWebView() {
        return this.app.appUrl.query.app === '1';
    }
    get isWebViewInIOSApp() {
        return this.isMobileAppWebView && this.app.appUrl.query.ios === '1';
    }
    get isWebViewInAndroidApp() {
        return this.isMobileAppWebView && this.app.appUrl.query.ios !== '1';
    }
}
__decorate([
    computed
], AppInfo.prototype, "isUserCurrentlyEditing", null);
__decorate([
    computed
], AppInfo.prototype, "isUserCurrentlyRunning", null);
__decorate([
    computed
], AppInfo.prototype, "isAppPaused", null);
__decorate([
    computed
], AppInfo.prototype, "instance", null);
